import { useState, useEffect, useReducer, useCallback } from "react";
import socket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { whatsAppsReducer } from "../../helpers/whatsAppState";

const RECONCILIATION_INTERVAL_MS = 30000;

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(whatsAppsReducer, []);
  const [loading, setLoading] = useState(true);

  const fetchSessions = useCallback(async ({
    showLoading = false,
    showError = false
  } = {}) => {
    if (showLoading) setLoading(true);

    try {
      const { data } = await api.get("/whatsapp/");
      dispatch({ type: "LOAD_WHATSAPPS", payload: data });
    } catch (err) {
      if (showError) toastError(err);
    } finally {
      if (showLoading) setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSessions({ showLoading: true, showError: true });
  }, [fetchSessions]);

  useEffect(() => {
    window.socket = socket;

    const handleWhatsApp = data => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
      }
    };

    const handleWhatsAppSession = data => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_SESSION", payload: data.session });
      }
    };

    const reconcileSessions = () => {
      fetchSessions();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        reconcileSessions();
      }
    };

    socket.on("whatsapp", handleWhatsApp);
    socket.on("whatsappSession", handleWhatsAppSession);
    socket.on("connect", reconcileSessions);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const reconciliationInterval = window.setInterval(() => {
      if (document.visibilityState === "visible") {
        reconcileSessions();
      }
    }, RECONCILIATION_INTERVAL_MS);

    return () => {
      socket.off("whatsapp", handleWhatsApp);
      socket.off("whatsappSession", handleWhatsAppSession);
      socket.off("connect", reconcileSessions);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.clearInterval(reconciliationInterval);
    };
  }, [fetchSessions]);

  return { whatsApps, loading };
};

export default useWhatsApps;
